import RevenueComponent from 'src/components/features/superAdmin/revenueComponent';

const RevenueScreenPage = () => <RevenueComponent />;

export default RevenueScreenPage;
